module.exports = __webpack_public_path__ + "media/images/pic/saska/join-us-430f36de68a4f2aa6b7c4f88cf80a39e.jpg";